import * as React from "react";
import { Container, Table } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";

const maxVisiblePages = 5;

export default function Rewards({accountInfo}) {
    const [rewards, setRewards] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        const fetchData = async () => {
          try {
            const apiUrl = `https://smeshi-api.com/account/${
              accountInfo.address
            }/rewards?sort=desc&limit=20&offset=${(currentPage - 1) * 20}`;
            const response = await fetch(apiUrl);
            const total = accountInfo.numberOfRewards;
            const result = await response.json();
    
            setRewards(() => setRewards(result));
            setTotalPages(Math.ceil(total/20));
          } catch (error) {
            setError(error.message);
          } finally {
            setLoading(false);
          }
        };
    
        fetchData();
      }, [currentPage, accountInfo]);

    const displayRewards = () => {
        if (rewards)
          return rewards.map((r, index) => {
            return (
              <tr key={index}>
                <td>{`${r.smesherId.slice(0, 4)}...${r.smesherId.slice(-4)}`}</td>
                <td>{(r.rewards/1000000000).toFixed(2)} SMH</td>
                <td>{r.layer}</td>
                <td>{new Date(r.timestamp*1000).toLocaleString()}</td>
              </tr>
            );
          });
      };

      const handlePageChange = (page) => {
        console.log(totalPages)
        setCurrentPage(page);
      };

      const handleFirstPage = () => {
        setCurrentPage(1);
      };
    
      const handleLastPage = () => {
        setCurrentPage(totalPages);
      };
      
      const renderPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
        for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
    
        return pageNumbers;
      }

    return(
        <Container>
      <Table striped bordered hover variant="dark" size="sm">
        <thead>
          <tr>
            <th>Smesher ID</th>
            <th>Rewards</th>
            <th>Layer</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>{displayRewards()}</tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={handleFirstPage} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
        {renderPageNumbers()}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={handleLastPage} disabled={currentPage === totalPages} />
      </Pagination>
    </Container>
    )
}